import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import StatusBadge from "@/components/StatusBadge";

export default function NCRRegister() {
  const [ncrs, setNcrs] = useState([]);
  useEffect(() => { api.get("/ncrs").then(r => setNcrs(r.data)); }, []);
  return (
    <div className="p-4 md:p-8" data-testid="ncr-register-page">
      <div className="mb-6">
        <div className="overline mb-1">Register</div>
        <h1 className="font-heading text-3xl font-black tracking-tighter sm:text-4xl">Non-Conformance Reports</h1>
      </div>
      <Card className="overflow-hidden border-slate-200">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-600">
            <tr><th className="px-4 py-3">NCR</th><th className="px-4 py-3">Issue</th><th className="px-4 py-3">Lot</th><th className="px-4 py-3">Status</th><th className="px-4 py-3">Due</th></tr>
          </thead>
          <tbody>
            {ncrs.map(n => (
              <tr key={n.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 font-mono font-semibold">{n.ncr_number}</td>
                <td className="px-4 py-3">{n.issue}</td>
                <td className="px-4 py-3 font-mono text-slate-600">{n.lot_id?.slice(0,8)}…</td>
                <td className="px-4 py-3"><StatusBadge status={n.status}/></td>
                <td className="px-4 py-3 text-slate-600">{n.due_date || "—"}</td>
              </tr>
            ))}
            {ncrs.length === 0 && <tr><td colSpan={5} className="px-4 py-8 text-center text-slate-500">No NCRs</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
